/* eslint-disable react/no-did-update-set-state */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import classNames from 'classnames';
import some from 'lodash/some'
import { connect } from 'react-redux';
import { compose } from 'redux';

import { Dialog } from 'primereact/dialog';
import { InputTextarea } from 'primereact/inputtextarea';

import { reactiveSection, deleteSection, getSectionTree } from '@actions/sections';
import { setCatalogCurrentSectionTree } from '@actions/catalogs';
import { sendActionToBitacora  } from '@actions/bitacora';

import { findSectionInTree } from '@utils/general';

import { LANGUAGE_DEFAULT } from '@constants/general'

class DeleteAuthorizedModalSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      justification: '',
      errors: []
    }
  }

  componentDidUpdate (prevProps) {
    if (!prevProps.display && this.props.display) {
      this.setState({
        justification: '',
        errors: []
      })
    }
  }

  onSubmit = async (actionType) => {
    // e.preventDefault();
    const { onContinueAction, onHidden } = this.props
    const { justification } = this.state
    const validate = await this.validateFieldsReject()
    if (some(validate, {})) return true
		actionType()
  }

	onReactiveDocument = async () => {
		const { reactiveSection, data, onContinueAction, onHidden } = this.props
		const { justification } = this.state
    const response = await reactiveSection({...data, justification});

		if (!response?.status) {
      await this.setState({ transactionNameOpt: 'reactivarSeccion' })
      await this.sendCommentToBitacora()
			onContinueAction()
		}
		return onHidden()

	}

	onConfirmDeleteDocument = async () => {
		const { deleteSection, data, onContinueAction, onHidden, getSectionTree, setCatalogCurrentSectionTree } = this.props
		const { justification } = this.state
    const type = "physical"
    const response = await deleteSection({...data, justification, type});

		if (!response?.status) {
      await this.setState({ transactionNameOpt: 'bajaFísicaSeccion' })
      await this.sendCommentToBitacora()
			onContinueAction()

      await getSectionTree()
      await setCatalogCurrentSectionTree()

		}
		return onHidden()
	}

  sendCommentToBitacora = async () => {
    const { sendActionToBitacora, data } = this.props
    const { transactionNameOpt, justification } = this.state
    const nameSection = data.nombre[LANGUAGE_DEFAULT]
    const dataBitacora = {
      transactionName: transactionNameOpt || 'Seccion',
      reason: `${nameSection} || ${justification}`,
    }
    await sendActionToBitacora(dataBitacora)
  }

  validateFieldsOnchange = (name, value) => {
    const { errors } = this.state
    if (errors[name] && value) {
      delete errors[name]
      this.setState({errors})
    }
  }

  validateFieldsReject = async () => {
    const { t, label } = this.props
    const { justification } = this.state
    let errors = {}
    if (!justification) errors = { ...errors, 'justification': `${t( label || 'Justificación del cambio')} ${t('es requerido')}`}
    this.setState({errors})
    return errors
  }

  isFormFieldValid = (name) =>
    !!(this.state.errors[name]);

  getFormErrorMessage = (name) =>
    this.isFormFieldValid(name) && (
      <small className="p-error">{this.state.errors[name]}</small>
    );

  findChildrensLabels = (data, accum = []) => {
    accum.push(data?.label)
      if (data?.children) {
        data.children.map(item => {
          return this.findChildrensLabels(item, accum)
        })
      }
      return accum
    }
  
  render () {
    const { t, display, onHidden, description, categoriesSectionCatalog, data } = this.props
    let findSectionsToDelete = []
    if (data?.id) {
      const findInTree = findSectionInTree(data?.id, categoriesSectionCatalog)
      // Temporal
      findSectionsToDelete = this.findChildrensLabels(findInTree)
    }

    const children = (
      <div className="p-mt-2 p-fluid">
        <div className="p-col p-pb-3 p-text-center">
          <label className="">{description}</label>
        </div>
        <div className="p-col">
          <label className="">{t('El usuario Juan López solicito la eliminación de esta sección')}</label>
          <br/>
          <br/>
          <label className="">{t('¿Esta seguro que desea eliminar definitivamente este seccion?')}</label>
          <br/>
          <br/>
          <label className="">{t('Considere que la sección tiene la siguiente estructura que también será eliminada.')}</label>
          {(findSectionsToDelete || []).map(item => (<ul key={item}>{item}</ul>))}
        </div>
				<br/>
				<br/>
        <div className="p-col">
          <label className="">{t('Justificación del cambio')}</label>
        </div>
        <InputTextarea
          name="justification"
          onChange={(e) =>
            this.setState({ justification: e.target.value }, this.validateFieldsOnchange('justification', e.target.value))
          }
          rows={5}
          cols={30}
          className={classNames({
            'p-invalid': this.isFormFieldValid(`justification`),
          })}
        />
        {this.getFormErrorMessage(`justification`)}
        <div className="p-dialog-footer custom">
          <div className="p-d-flex p-jc-sm-between">
            <button className="p-button p-component p-button-raised p-button-secondary p-button-text p-mr-5" type="button" onClick={() => onHidden()}>
              <span className="p-button-label p-c">Cerrar</span>
            </button>
            <div>
              <button className="p-button p-button-success p-component" onClick={() => this.onSubmit(() => this.onReactiveDocument())}>
                <span className="p-button-label p-c">{t('Reactivar sección')}</span>
              </button>
              <button
                type="button"
                className="p-button p-button-danger p-component"
                onClick={() => this.onSubmit(() => this.onConfirmDeleteDocument())}
              >
                <span className="p-button-label p-c">{t('Eliminar sección')}</span>
              </button>
            </div>

          </div>
        </div>
      </div>
    )

    return (
      <Dialog
        header={t('Eliminación de una sección autorizada')}
        visible={display}
        breakpoints={{'960px': '75vw'}}
        style={{ width: '50vw' }}
        onHide={onHidden}
      >
        {children}
      </Dialog>
    )
  }
}

const mapStateToProps = (state) => ({
  categoriesSectionCatalog: state.catalogs.sectionTreeCurrentCatalog,
})

const mapDispatchToProps = {
  reactiveSection,
	deleteSection,
  getSectionTree,
  setCatalogCurrentSectionTree,
  sendActionToBitacora
};

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
  )(DeleteAuthorizedModalSection)